var _defs, _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNegru(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.7,0,0,0.7,149.57575757575756,282.1265587044535)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 396 247",
    "data-background-color": "#ffffff",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,0.2400000000000091,-0.09999999999999432)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 247.2",
    height: 247.2,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 247.2",
    height: 247.2,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,75.54432,95.11432204314406)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 56.97135591371186",
    height: 56.97135591371186,
    width: 244.43135999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 56.97135591371186",
    height: 56.97135591371186,
    width: 244.43135999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 56.97135591371186",
    height: 56.97135591371186,
    width: 244.43135999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 56.97135591371186",
    height: 56.97135591371186,
    width: 244.43135999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 56.97135591371186",
    height: 56.97135591371186,
    width: 244.43135999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 56.97135591371186",
    height: 56.97135591371186,
    width: 244.43135999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 244.43135999999998,
    viewBox: "3.450000047683716 -36 201.6300048828125 47",
    height: 56.97135591371186,
    "data-palette-color": "#070707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65 11L3.45 11 3.45-24.8 7.25-24.8 7.65-20.7Q8.85-22.5 11.08-23.95 13.3-25.4 16.75-25.4L16.75-25.4Q20.45-25.4 23.2-23.7 25.95-22 27.48-19.05 29-16.1 29-12.35L29-12.35Q29-8.6 27.48-5.68 25.95-2.75 23.18-1.07 20.4 0.6 16.7 0.6L16.7 0.6Q13.65 0.6 11.28-0.65 8.9-1.9 7.65-4.15L7.65-4.15 7.65 11ZM16.25-3.05L16.25-3.05Q18.75-3.05 20.65-4.23 22.55-5.4 23.65-7.5 24.75-9.6 24.75-12.4L24.75-12.4Q24.75-15.2 23.65-17.3 22.55-19.4 20.65-20.58 18.75-21.75 16.25-21.75L16.25-21.75Q13.75-21.75 11.85-20.58 9.95-19.4 8.85-17.3 7.75-15.2 7.75-12.4L7.75-12.4Q7.75-9.6 8.85-7.5 9.95-5.4 11.85-4.23 13.75-3.05 16.25-3.05ZM37.4-30.3L37.4-30.3Q36.15-30.3 35.32-31.13 34.5-31.95 34.5-33.2L34.5-33.2Q34.5-34.4 35.32-35.2 36.15-36 37.4-36L37.4-36Q38.6-36 39.45-35.2 40.3-34.4 40.3-33.2L40.3-33.2Q40.3-31.95 39.45-31.13 38.6-30.3 37.4-30.3ZM39.5 0L35.3 0 35.3-24.8 39.5-24.8 39.5 0ZM58.2 0.6L58.2 0.6Q54.65 0.6 51.82-1.03 49-2.65 47.37-5.58 45.75-8.5 45.75-12.4L45.75-12.4Q45.75-16.3 47.37-19.23 49-22.15 51.82-23.78 54.65-25.4 58.2-25.4L58.2-25.4Q62.6-25.4 65.62-23.1 68.65-20.8 69.45-16.95L69.45-16.95 65.15-16.95Q64.65-19.25 62.7-20.53 60.75-21.8 58.15-21.8L58.15-21.8Q56.05-21.8 54.2-20.75 52.35-19.7 51.2-17.6 50.05-15.5 50.05-12.4L50.05-12.4Q50.05-9.3 51.2-7.2 52.35-5.1 54.2-4.03 56.05-2.95 58.15-2.95L58.15-2.95Q60.75-2.95 62.7-4.23 64.65-5.5 65.15-7.85L65.15-7.85 69.45-7.85Q68.7-4.1 65.65-1.75 62.6 0.6 58.2 0.6ZM88.54 0.6L88.54 0.6Q85.49 0.6 83.12-0.65 80.74-1.9 79.49-4.15L79.49-4.15 79.09 0 75.29 0 75.29-36 79.49-36 79.49-20.7Q80.69-22.5 82.92-23.95 85.14-25.4 88.59-25.4L88.59-25.4Q92.29-25.4 95.04-23.7 97.79-22 99.32-19.05 100.84-16.1 100.84-12.35L100.84-12.35Q100.84-8.6 99.32-5.68 97.79-2.75 95.02-1.07 92.24 0.6 88.54 0.6ZM88.09-3.05L88.09-3.05Q90.59-3.05 92.49-4.23 94.39-5.4 95.49-7.5 96.59-9.6 96.59-12.4L96.59-12.4Q96.59-15.2 95.49-17.3 94.39-19.4 92.49-20.58 90.59-21.75 88.09-21.75L88.09-21.75Q85.59-21.75 83.69-20.58 81.79-19.4 80.69-17.3 79.59-15.2 79.59-12.4L79.59-12.4Q79.59-9.6 80.69-7.5 81.79-5.4 83.69-4.23 85.59-3.05 88.09-3.05ZM117.99 0.6L117.99 0.6Q114.49 0.6 111.69-1 108.89-2.6 107.27-5.53 105.64-8.45 105.64-12.4L105.64-12.4Q105.64-16.35 107.29-19.28 108.94-22.2 111.77-23.8 114.59-25.4 118.09-25.4L118.09-25.4Q121.59-25.4 124.39-23.8 127.19-22.2 128.81-19.28 130.44-16.35 130.44-12.4L130.44-12.4Q130.44-8.45 128.79-5.53 127.14-2.6 124.32-1 121.49 0.6 117.99 0.6ZM117.99-3L117.99-3Q120.14-3 121.99-4.05 123.84-5.1 124.99-7.2 126.14-9.3 126.14-12.4L126.14-12.4Q126.14-15.5 125.02-17.6 123.89-19.7 122.04-20.75 120.19-21.8 118.09-21.8L118.09-21.8Q115.94-21.8 114.09-20.75 112.24-19.7 111.09-17.6 109.94-15.5 109.94-12.4L109.94-12.4Q109.94-9.3 111.09-7.2 112.24-5.1 114.07-4.05 115.89-3 117.99-3ZM144.54 0.6L144.54 0.6Q141.44 0.6 139.39-0.45 137.34-1.5 136.34-3.25 135.34-5 135.34-7.05L135.34-7.05Q135.34-10.85 138.24-12.9 141.14-14.95 146.14-14.95L146.14-14.95 152.84-14.95 152.84-15.25Q152.84-18.5 151.14-20.18 149.44-21.85 146.59-21.85L146.59-21.85Q144.14-21.85 142.36-20.63 140.59-19.4 140.14-17.05L140.14-17.05 135.84-17.05Q136.09-19.75 137.66-21.6 139.24-23.45 141.59-24.43 143.94-25.4 146.59-25.4L146.59-25.4Q151.79-25.4 154.41-22.63 157.04-19.85 157.04-15.25L157.04-15.25 157.04 0 153.29 0 153.04-4.45Q151.99-2.35 149.96-0.88 147.94 0.6 144.54 0.6ZM145.19-2.95L145.19-2.95Q147.59-2.95 149.31-4.2 151.04-5.45 151.94-7.45 152.84-9.45 152.84-11.65L152.84-11.65 152.84-11.7 146.49-11.7Q142.79-11.7 141.26-10.43 139.74-9.15 139.74-7.25L139.74-7.25Q139.74-5.3 141.16-4.13 142.59-2.95 145.19-2.95ZM167.54 0L163.34 0 163.34-24.8 167.14-24.8 167.49-20.05Q168.64-22.5 170.99-23.95 173.34-25.4 176.79-25.4L176.79-25.4 176.79-21 175.64-21Q173.44-21 171.59-20.23 169.74-19.45 168.64-17.6 167.54-15.75 167.54-12.5L167.54-12.5 167.54 0ZM191.78 0.6L191.78 0.6Q188.08 0.6 185.31-1.1 182.53-2.8 181.01-5.75 179.48-8.7 179.48-12.45L179.48-12.45Q179.48-16.2 181.03-19.13 182.58-22.05 185.33-23.73 188.08-25.4 191.83-25.4L191.83-25.4Q194.88-25.4 197.23-24.15 199.58-22.9 200.88-20.65L200.88-20.65 200.88-36 205.08-36 205.08 0 201.28 0 200.88-4.1Q199.68-2.3 197.43-0.85 195.18 0.6 191.78 0.6ZM192.23-3.05L192.23-3.05Q194.73-3.05 196.66-4.23 198.58-5.4 199.66-7.5 200.73-9.6 200.73-12.4L200.73-12.4Q200.73-15.2 199.66-17.3 198.58-19.4 196.66-20.58 194.73-21.75 192.23-21.75L192.23-21.75Q189.78-21.75 187.86-20.58 185.93-19.4 184.86-17.3 183.78-15.2 183.78-12.4L183.78-12.4Q183.78-9.6 184.86-7.5 185.93-5.4 187.86-4.23 189.78-3.05 192.23-3.05Z",
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#070707",
    className: "undefined-text-0",
    "data-fill-palette-color": "primary",
    id: "text-0"
  })))))))))))))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M199.171 89.114L199.171 29.845 386.68 29.845 386.68 217.355 199.171 217.355 199.171 158.086 204.308 158.086 204.308 212.217 381.542 212.217 381.542 34.983 204.308 34.983 204.308 89.114Z",
    fill: "#070707",
    stroke: "transparent",
    "data-fill-palette-color": "primary"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 395.52,
    height: 247.2,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegru);
export default __webpack_public_path__ + "static/media/negru.788d4e7cab8a5a49f2a4ca388a1d84fe.svg";
export { ForwardRef as ReactComponent };